/* MMT - "Try it live" simulator window. Works with snippet mmt-try-live. */
(function(){
  if(window.__mmtTryLive) return; window.__mmtTryLive=1;
  var LT='<', ST='/';
  function wrap(inner){
    return LT+'!doctype html>'+LT+'html lang="en">'+LT+'head>'+LT+'meta charset="utf-8">'+LT+'meta name="viewport" content="width=device-width,initial-scale=1">'+LT+'base target="_top">'+LT+ST+'head>'+LT+'body>'+inner+LT+ST+'body>'+LT+ST+'html>';
  }
  function setup(M){
    if(M.__tl) return; M.__tl=1;
    if(M.parentNode!==document.body) document.body.appendChild(M);
    var id=M.id, frame=M.querySelector('.mmt-tl-modal__frame'), loaded=false, last=null;
    function open(){
      last=document.activeElement; M.classList.add('on'); document.documentElement.style.overflow='hidden';
      if(!loaded){
        loaded=true;
        var f=document.createElement('iframe'); f.title='Simulator'; f.setAttribute('allow','fullscreen; autoplay');
        var tpl=document.getElementById(id+'-doc'), html=tpl?String(tpl.innerHTML||'').trim():'';
        if(html) f.srcdoc=wrap(html); else f.src=M.getAttribute('data-src');
        f.onload=function(){ var l=frame.querySelector('.mmt-tl-modal__load'); if(l) l.parentNode.removeChild(l); try{ f.focus(); }catch(e){} };
        frame.appendChild(f);
      }
      var x=M.querySelector('.mmt-tl-modal__x'); if(x) x.focus();
    }
    function close(){ M.classList.remove('on'); document.documentElement.style.overflow=''; if(last&&last.focus) last.focus(); }
    var btns=document.querySelectorAll('[data-mmt-tl-open]');
    for(var i=0;i<btns.length;i++){ if(btns[i].getAttribute('data-mmt-tl-open')===id) btns[i].addEventListener('click',open); }
    M.querySelector('.mmt-tl-modal__x').addEventListener('click',close);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&M.classList.contains('on')) close(); });
  }
  function init(){ var ms=document.querySelectorAll('.mmt-tl-modal'); for(var i=0;i<ms.length;i++) setup(ms[i]); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
